var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',[_c('b-nav-item',[_c('router-link',{attrs:{"to":"/product"}},[_vm._v("محصولات")])],1),_c('b-nav-item',[_c('router-link',{attrs:{"to":"/address"}},[_vm._v("آدرس")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }